import request from '@/utils/request'

export default {
  /**
   * 获取分类商品
   */
  listWithProductSkus(params) {
    return request.get('/categories/list/with-product-skus', { params })
  },

  /**
   * 获取员工可赠送商品、套餐
   */
  getStaffAvailableGivingPackageProducts(params) {
    return request.get('/categories/staff-available-giving-package-products/list', { params })
  }
}
